<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '新增配置项' : '修改配置项'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="650px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
        size="mini"
      >
        <el-form-item label="渠道" prop="channelId">
          <channel-selector
            placeholder="请选择"
            @ready="onChannelSelectorReady"
            @change="onChannelSelectorChange"
            enableFullChannels
            ref="channelSelector"
          >
          </channel-selector>
        </el-form-item>
        <el-form-item label="最低版本" prop="minVersion">
          <el-input
            v-model="form.minVersion"
            placeholder="比如1.0.1"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="最高版本" prop="maxVersion">
          <el-input
            v-model="form.maxVersion"
            placeholder="比如1.0.1"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="环境" prop="env">
          <el-select v-model="form.env" placeholder="请选择">
            <el-option
              v-for="item in envOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="form.remark"
            placeholder="多少写点儿什么吧..."
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()" style="margin-left: 30px">{{
          this.value.isCreate ? "确定" : "保存"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";

import ChannelSelector from "@/components/ChannelSelector";

export default {
  data() {
    return {
      visible: true,
      form: {
        channelId: "",
        minVersion: "",
        maxVersion: "",
        env: "",
        remark: "",
      },
      rules: {
        channelId: [{ required: true, message: " ", trigger: "blur" }],
        minVersion: [{ required: true, message: " ", trigger: "blur" }],
        maxVersion: [{ required: true, message: " ", trigger: "blur" }],
        env: [{ required: true, message: " ", trigger: "blur" }],
      },
      envOptions: [
        {
          value: 0,
          label: "开发",
        },
        {
          value: 1,
          label: "测试",
        },
        {
          value: 2,
          label: "审核",
        },
        {
          value: 3,
          label: "正式",
        },
      ],
    };
  },

  props: {
    value: Object,
  },

  components: {
    ChannelSelector,
  },

  created() {
    if (!this.value.isCreate) {
      this.form.channelId = this.value.oldData.channelId;
      this.form.minVersion = this.value.oldData.minVersion;
      this.form.maxVersion = this.value.oldData.maxVersion;
      this.form.env = this.value.oldData.env;
      this.form.remark = this.value.oldData.remark;
    } else {
      this.form.env = 3; // 给一个默认值
    }
  },

  methods: {
    async onChannelSelectorReady() {
      if (!this.value.isCreate) {
        this.$refs.channelSelector.value = this.form.channelId;
      }
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.channelId = newChannelId;
    },

    /**
     * 提交表单
     */
    submit() {
      if (this.form.channelId === "") {
        this.$alert("请选择渠道");
        return;
      }
      
      if (this.value.isCreate) {
        this.add();
      } else {
        this.update();
      }
    },

    /**
     * 新增
     */
    add() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/api/admin/v1/version/add`,
            {
              version: {
                channelId: this.form.channelId,
                minVersion: this.form.minVersion,
                maxVersion: this.form.maxVersion,
                env: this.form.env,
                remark: this.form.remark,
              },
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    /**
     * 修改
     */
    update() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/api/admin/v1/version/update`,
            {
              version: {
                id: this.value.oldData.id,
                channelId: this.form.channelId,
                minVersion: this.form.minVersion,
                maxVersion: this.form.maxVersion,
                env: this.form.env,
                remark: this.form.remark,
              },
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>